import { render, staticRenderFns } from "./UpdateSupplier.vue?vue&type=template&id=1f2409fe"
import script from "./UpdateSupplier.vue?vue&type=script&lang=js"
export * from "./UpdateSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports